export default __webpack_public_path__ + "static/media/ArrowIcon.fe6ac66e.svg";